import { useEffect } from 'react';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { massiveExcludedColumnConfig } from '@/app/KeywordResearch/config/massiveExcludedColumnConfig';
import { useLazyGetExcludedKeywordsQuery } from '@/app/KeywordResearch/api/massiveApi';
import { Modal } from '@/components/common/AppModal';
import { Button } from 'react-bootstrap';

type MassiveExcludedKeywordsModalProps = {
  show: boolean;
  onHide: () => void;
  taskId: string;
};

const MassiveExcludedKeywordsModal = ({
  show,
  onHide,
  taskId
}: MassiveExcludedKeywordsModalProps) => {
  const [
    getExcludedKeywords,
    { data, isLoading, isFetching, isError, isUninitialized }
  ] = useLazyGetExcludedKeywordsQuery();

  useEffect(() => {
    if (show && taskId) {
      getExcludedKeywords(taskId);
    }
  }, [show, taskId, getExcludedKeywords]);

  const excludedKeywords = data?.data?.user ?? [];
  const excludedCount = data?.data?.excluded_count ?? excludedKeywords.length;
  const showPreload = isUninitialized || isLoading || isFetching;

  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header>
        <Modal.Title className="fs-0">
          کلمات فیلتر شده ({showPreload ? '...' : excludedCount})
        </Modal.Title>
        <FalconCloseButton onClick={onHide} />
      </Modal.Header>
      <Modal.Body className="p-2">
        {showPreload ? (
          <AgGridSkeleton height="480px" />
        ) : isError ? (
          <p className="text-center text-danger mb-0">
            خطا در دریافت کلمات فیلتر شده.
          </p>
        ) : excludedKeywords.length ? (
          <AgGridWrapper
            columns={massiveExcludedColumnConfig}
            height="480px"
            data={excludedKeywords}
            settings={{
              pagination: true,
              fullscreen: false,
              changeHeight: false,
              resetGrid: false,
              saveGrid: false,
              sideBar: false,
              exportBtn: true
            }}
          />
        ) : (
          <p className="text-center text-muted mb-0">موردی یافت نشد.</p>
        )}
      </Modal.Body>
      <Modal.Footer className="p-2">
        <Button variant="secondary" onClick={onHide}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MassiveExcludedKeywordsModal;
